import BaseApi, { API_BASE_URL, ApiResponse } from './base';

export interface Product {
  id: string;
  name: string;
  tagline?: string;
  description?: string;
  category: {
    id: string;
    name: string;
  };
  status: 'operational' | 'beta' | 'maintenance';
  icon?: string;
  url?: string;
  features: string[];
  targetUsers: string[];
  slackChannels: string[];
  contactPerson?: {
    name: string;
    email: string;
    role?: string;
  };
  metrics: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProductRequest {
  name: string;
  tagline?: string;
  description?: string;
  categoryId: string;
  status?: 'operational' | 'beta' | 'maintenance';
  icon?: string;
  url?: string;
  features?: string[];
  targetUsers?: string[];
  slackChannels?: string[];
  contactPerson?: {
    name: string;
    email: string;
    role?: string;
  };
  metrics?: Record<string, any>;
}

export interface UpdateProductRequest {
  name?: string;
  tagline?: string;
  description?: string;
  categoryId?: string;
  status?: 'operational' | 'beta' | 'maintenance';
  icon?: string;
  url?: string;
  features?: string[];
  targetUsers?: string[];
  slackChannels?: string[];
  contactPerson?: {
    name: string;
    email: string;
    role?: string;
  };
  metrics?: Record<string, any>;
}

class ProductsApi extends BaseApi {
  constructor(baseURL: string = API_BASE_URL) {
    super(baseURL);
  }

  async getProducts(params?: {
    cursor?: string;
    limit?: number;
    categoryId?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<ApiResponse<Product[]>> {
    return this.get<Product[]>(`/products`, {
      params: params || {},
    });
  }

  async getProduct(id: string): Promise<ApiResponse<Product>> {
    return this.get<Product>(`/products/${id}`);
  }

  async createProduct(data: CreateProductRequest): Promise<ApiResponse<Product>> {
    return this.post<Product>('/products', data);
  }

  async updateProduct(id: string, data: UpdateProductRequest): Promise<ApiResponse<Product>> {
    return this.patch<Product>(`/products/${id}`, data);
  }

  async deleteProduct(id: string): Promise<ApiResponse<{}>> {
    return this.delete<{}>(`/products/${id}`);
  }
}

export default new ProductsApi();
